import React, { useEffect, useState }  from 'react';
import { Redirect } from 'react-router-dom'
import auth from '../service/Auth'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import GPAP_Breadcrumb from "../../gpap-lib/GPAP_Breadcrumb";
import "./navigation-bar.css";
import LogoutButton from "./LogoutButton";
import NavigationMenu from "./navigation-menu/NavigationMenu";
import Avatar from '@mui/material/Avatar';

import BlackButton from "./components/BlackButton.js"
import NotificationBell from './components/NotificationBell';
import AlertMissing from './components/AlertMissing'

import { experiments_view } from '../service/apis';

const notification = window.notification;


const NavigationBar = (props) => {

    const [welcomeMessage, setWelcomeMessage] = useState("");
    const [keycloak, setKeycloak] = useState({});
    const [authenticated, setAuhenticated] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [experimentsMissing, setExperimentsMissing] = useState(0);

    const loadNotifications = () => {
        // Read notification js and get just the ones with less than a mounth
        let resultProductData = notification.filter(a => {
            let aDate = new Date(a.date);
            let endDate = new Date();
            let startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 1);
            return (aDate >= startDate && aDate <= endDate);
        });

        // Sort them by data
        let dateSortedNotifications = resultProductData.sort((a,b) => {
            let dateA = new Date(a.date);
            let dateB = new Date(b.date);
            return dateA - dateB;
        });
        setNotificationList(dateSortedNotifications);
    }

    const updateBarValues = () => {
        // Set keycloack values
        setKeycloak(auth.user.keycloak);
        setAuhenticated(auth.user.authenticated);
        // Set welcome message
        if (authenticated) setWelcomeMessage("Welcome " + keycloak.tokenParsed.name);
        else setWelcomeMessage("Welcome Guest");
        // Get and update notification list
        loadNotifications();
    }

    useEffect(() => {
        updateBarValues();
    },[])

    useEffect(() => {
        updateBarValues();
    },[auth.user.keycloak,auth.user.authenticated])

    useEffect(() => {
        // declare the async data fetching function
        const fetchData = async () => {
            let bodyPost = { 
                "page" : 1, "pageSize" : 1,
                "fields" : ["LocalExperimentID", "Owner", "ExperimentID","LOADDATE"],
                "filtered":[{"id":"Owner","value":auth.getUserGroups()}, {"id":"file_submission_close","value":["false"]}]
            }
            const queryItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                               .then((response) => { return response.json()})
                               .then((dataApi) => {
                                   return dataApi["_meta"]["total_items"];
                                });
            setExperimentsMissing(queryItems);
        }
        // Check keycloack
        if(auth.getToken()) fetchData().catch(console.error);
    },[auth.user.keycloak])

    const Details = () => {
        let userName = keycloak.tokenParsed.preferred_username;
        return(
            <Button> 
                <Avatar
                    style={{
                        background: "rgb(69, 117, 180)",
                        color: "white",
                        width: "30px",
                        height: "30px",
                        margin: "5px"
                        }}>{userName.charAt(0).toUpperCase()}
                </Avatar> 
                {userName} 
            </Button>
        ); 
    }


    return (
        <div className="pageHeader">
            <Grid
                container
                spacing={2}>
                <Grid
                    item
                    xs={5}>
                    <Grid item>
                        <NavigationMenu 
                            title={"Data Submission"}
                            orange={false}
                            items={[ {label:"Phenotypic Data", to:"/phenostore/"},
                                     {label:"Experiments & Files", to:"/submission/"}]}
                        />
                        <NavigationMenu
                            title={"Data Analysis"}
                            orange={false}
                            items={[ {label:"Genomic Analysis", to: "/nextgpap"},
                                {label:"Cohort Creation", to: "/cohortapp"}]}
                        />
                        <NavigationMenu 
                            title={"Data Management"}
                            orange={true}
                            items={[ {label:"Browse Phenotypic Participants", to:"/phenobrowse/"},
                                     {label:"Browse Experiments & Files", to:"/management/"}]}
                        />
                    </Grid>
                    <Grid item>
                        <GPAP_Breadcrumb/>
                    </Grid>
                </Grid>
                <Grid item xs={2} style={{textAlign: "center"}}>
                    <div>
                        <a href={origin} style={{color: "black"}}>
                        <img src={window.config.static_files + "/img/gpap_logo.svg"} alt="GPAP"/>
                    </a>
                    </div>
                </Grid>
                <Grid item xs={5} style={{textAlign: "center"}}>
                    <div className="header-right">
                        {(experimentsMissing > 0) ? <AlertMissing experimentsMissing={experimentsMissing} userName={keycloak.tokenParsed.preferred_username} /> : null}
                        {(notificationList.length > 0) ? <NotificationBell notificationList={notificationList} /> :  null}
                        <BlackButton href={origin + "/gpap_doc/experiment_data.html" }>Guidelines</BlackButton>
                        {(authenticated) ? <Details/> :  <BlackButton>{welcomeMessage} </BlackButton>}
                        <LogoutButton/>
                        <div className={"navbar_links"}>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    );  
    
}

export default NavigationBar;
